import { render, staticRenderFns } from "./BestPriceColumnHeader.vue?vue&type=template&id=1226896b&scoped=true&"
import script from "./BestPriceColumnHeader.vue?vue&type=script&lang=js&"
export * from "./BestPriceColumnHeader.vue?vue&type=script&lang=js&"
import style0 from "./BestPriceColumnHeader.vue?vue&type=style&index=0&id=1226896b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1226896b",
  null
  
)

export default component.exports